// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Btjsy","answerBtn":"styles_answerBtn__RKjTk","active":"styles_active__vJcII"};